import $ from 'jquery'

const $tabs = $('.js-services-tabs')
const $sections = $('.js-services-tabs-sections')

export default function initServicesTabs() {
  if ( !$tabs.length ) return

  tabControl()

  var hash = window.location.hash.replace('#', '')
  if ( hash ) {
    var savedScroll = window.pageYOffset
    activateTab(hash)
    setTimeout(function() { window.scrollTo(0, savedScroll) }, 0)
  }

  var resizeTimer

  $(window).on('resize', function () {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(function () {
      tabControl()
    }, 250)
  })
}

function activateTab(slug) {
  var $item = $tabs.find('.services-tabs__item#' + slug)
  if ( !$item.length ) return

  var $nav   = $tabs.find('.services-tabs__nav')
  var $links = $nav.find('a')
  var $items = $tabs.find('.services-tabs__item')

  $links.removeClass('active')
  $items.removeClass('active')

  $item.addClass('active')
  $links.filter('[href="#' + slug + '"]').addClass('active')

  switchSection($item.data('index'))

  history.replaceState(null, '', '#' + slug)
}

function switchSection(index) {
  if ( !$sections.length ) return
  $sections.find('.services-tabs__section').removeClass('active')
  $sections.find('.services-tabs__section[data-section="' + index + '"]').addClass('active')
}

function tabControl() {
  var $nav = $tabs.find('.services-tabs__nav')

  if ( $nav.is(':visible') ) {
    $nav.find('a').off('click').on('click', function (e) {
      e.preventDefault()

      var slug = $(this).attr('href').replace('#', '')
      activateTab(slug)
    })

  } else {
    $tabs.find('.services-tabs__item').off('click').on('click', function () {
      var slug = $(this).attr('id')
      activateTab(slug)
    })

  }
}
